<template>
    <el-drawer
            :title="itemData ? '编辑问题' : '创建问题'"
            :visible.sync="drawerShow"
            :wrapperClosable="false"
            :destroy-on-close="true"
            size="auto"
            @close="close"
            append-to-body	
        >
        <div class="drawer-content">
            <el-form
                    :model="formData"
                    :rules="rules"
                    ref="formData"
                    label-position="top"
                    size="medium"
                >
                <el-form-item prop="questionName" label="问题:">
                    <el-input v-model="formData.questionName" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item v-for="(item,index) in formData.optionList" :key="index" :prop="`optionList[${index}].optionName`" :rules="[{required: true, message: `请填写答案选项`}]">
                    <span slot="label">
                        答案选项{{index + 1}}： 
                        <el-radio v-model="formData.optionList[index].correct" size="mini" :label="1" @change="changeCorrect(index)">正确答案</el-radio>
                        <el-button v-if="formData.optionList.length > 2 && formData.optionList[index].correct != 1" size="mini" type="text" icon="el-icon-delete" @click="delOption(index)">删除</el-button>
                    </span>
                    <el-input v-model="item.optionName" maxlength="40"></el-input>
                </el-form-item>
            </el-form>
            <div class="MT30">
                <el-button size="medium" plain type="primary" style="width: 100%" icon="el-icon-plus" @click="addOption()">新增答案选项</el-button>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    questionName: "",
    optionList: [{
        optionName:"",
        correct: 1,
    },{
        optionName:"",
        correct: 0
    }]
}
export default {
    data(){
        return{
            drawerShow: false,
            formData:{
                ...defaultFormData
            },
            btnLoading:false,
            rules: {
                questionName: [{ required: true, message: "请输入问题" }]
            },
            itemData: null,
        }
    },
    methods: {
        close() {
            // this.$refs.formData.resetFields();
            // this.formData = {
            //     ...defaultFormData
            // }
            this.drawerShow = false;
        },
        show(data,index){
            this.itemData = {...data}
            if(data){
                this.formData = JSON.parse( JSON.stringify( {
                    ...defaultFormData,
                    ...data,
                    index: index
                }))
            }else{
                this.formData = {
                    ...defaultFormData,
                    optionList: [{
                        optionName:"",
                        correct: 1,
                    },{
                        optionName:"",
                        correct: 0
                    }]
                }
            }
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.$emit('onUpdate', this.formData);
                    this.close();
                } else {
                    return false;
                }
            });
        },
        //勾选正确答案选项
        changeCorrect(index){
            this.formData.optionList.map((v,i) => {
                if(i != index){
                    v.correct = 0
                }
            })
        },
        //新增答案选项
        addOption(){
            this.formData.optionList.push({
                optionName:"",
                correct: 0
            })
        },
        //删除答案选项
        delOption(index){
            this.formData.optionList = this.formData.optionList.filter((v,i) => i !== index)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>